import type { VoidFunctionComponent } from 'react';

import Button from '../generic/Button';
import { useDialogContext } from '../../contexts/DialogContext';
import { post } from '../../redux/api';
import useAsyncStatus from '../../hooks/useAsyncStatus';
import Text from '../generic/Text';

/**
 * Shows a button to trigger backfill issue sanitized locator data.
 */
export const BackfillIssueSanitizedLocators: VoidFunctionComponent = () => {
  const requestStatus = useAsyncStatus();
  const { onConfirm } = useDialogContext();

  const onButtonClick = () => {
    onConfirm({
      title: 'Backfill Issue Sanitized Locators',
      body: (
        <div>
          are you sure you want to backfill issue sanitized locator data
        </div>
      ),
      onConfirm: async () => {
        try {
          requestStatus.onPending();
          await post('/api/organizations/backfill-issue-sanitized-locators', {});
          requestStatus.onSuccess();
        } catch (e) {
          requestStatus.onError(e as Error);
        }
      },
    });
  };

  return (
    <div className="card">
      <Text.H4>Backfill Issue Sanitized Locators</Text.H4>
      <Text.Paragraph>
        This will queue a background job that backfills data required for IssuesV2
        vulnerability "Has Fix" filter.
      </Text.Paragraph>
      <Button onClick={onButtonClick}>
        Backfill
      </Button>
    </div>
  );
};

export default BackfillIssueSanitizedLocators;
